class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer-open');
    
    // Load cart immediately when component is connected
    this.loadCart();
  }

  async loadCart() {
    try {
      const response = await fetch(this.dataset.url);
      const html = await response.text();
      
      // Update the mini-cart content
      const miniCart = document.getElementById('mini-cart');
      if (miniCart) {
        const existingRecommendations = miniCart.querySelector('cart-recommendations');
        const existingRecommendationsHtml = existingRecommendations ? existingRecommendations.innerHTML : null;

        const nextInnerHtml = this.getSectionInnerHTML(html, '.shopify-section');

        // If recommendations already loaded once, preserve them to avoid re-fetch on re-render.
        if (existingRecommendationsHtml && existingRecommendationsHtml.trim().length) {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = nextInnerHtml;
          const nextRecommendations = wrapper.querySelector('cart-recommendations');
          if (nextRecommendations) {
            nextRecommendations.innerHTML = existingRecommendationsHtml;
          }
          miniCart.innerHTML = wrapper.innerHTML;
        } else {
          miniCart.innerHTML = nextInnerHtml;
        }
      }
      
      // Dispatch event to notify other components
      document.dispatchEvent(new CustomEvent('cartdrawer:loaded'));
      
    } catch (e) {
      console.error('Error loading cart:', e);
    }
  }

  open() {
    // const detailsElement = this.drawer?.querySelector('details');
    // if (!detailsElement || detailsElement.hasAttribute('open')) {
    //   return;
    // }
    
    this.drawer.openDrawer();

  }
// required function in other js
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      // Find ALL elements that match either class or ID for this section
      // This handles both single and multiple instances (like sticky header + main header)
      const elements = document.querySelectorAll(`.${section.id}, #${section.id}`);
      elements.forEach((element) => {
        if (element) {
          element.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id], 
            section.selector
          );
        }
      });
    });

    this.open();
  }

// required function in other js
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-total-price',
        section: 'cart-total-price',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }
}

customElements.define('mini-cart', MiniCart);